import React, { ReactElement } from "react";
import styles from "./contactUs.module.scss";
import classNames from "classnames";

export const ContactUs = (props: Props): ReactElement => {
  return (
    <section className={styles.base}>
      <div className={styles.wrapper}>
        <div className={styles.headingAndActions}>
          <div data-testid="texts" className={styles.texts}>
            <div data-testid="badge" className={styles.badge}>
              <span className={styles.badgeText}>{props.badgeText}</span>
            </div>
            <p className={styles.title}>{props.title}</p>
            <p className={styles.desc}>{props.desc}</p>
          </div>
        </div>
      </div>
      <div className={classNames(styles.wrapper, styles.gridlike)}>
        {props.children}
      </div>
    </section>
  );
};

interface Props extends React.PropsWithChildren {
  badgeText?: string;
  badgeIcon?: React.ElementType;
  title: string;
  desc: string;
}
